import { createPlotSidebar } from "../../../plot/Utils.js";
import { generateTable } from "../../../ui/table/Utils.js";
import { DwsLayer } from "../../layer/DwsLayer.js";

// static plot container
let plotInterval = null;
let plotTimeout = null;

function clearTimers() {
    if (plotInterval) clearInterval(plotInterval);
    if (plotTimeout) clearTimeout(plotTimeout);
    plotInterval = null;
    plotTimeout = null;
}

function plot(target, layer, feature, table) {
    clearTimers();

    const createPlot = () => {
        clearTimers();
        createPlotSidebar(target, {
            layer: layer,
            row: feature._data,
            table: table
        }, layer.dataFrameOriginal, {
            defaultYAxis: layer.defaultYAxis,
            invertYAxis: layer.invertYAxis,
            defaultXAxis: layer.defaultXAxis,
            invertXAxis: layer.invertXAxis,
            groupBy: layer.groupByColumn,
            hiddenColumns: layer.hiddenColumns
        });

        if (layer instanceof DwsLayer) {
            target.insertAdjacentHTML("afterbegin", `
                <h3>PLEASE NOTE</h3>
                <div>Data is aggregated by <b>${layer.aggregate}</b> and limited to <b>${layer.limit}</b> points for performance reasons!</div>
            `);
        }
    };

    // only init plot if the target is visible in DOM (offsetParent == null if not displayed)
    // use timeout to push to end of eventloop. If not in DOM check repeatedly
    plotTimeout = setTimeout(() => {
        if (target.offsetParent) {
            createPlot()
        } else {
            plotInterval = setInterval(() => {
                if (target.offsetParent) createPlot();
            }, 700);
        }
    }, 50);
}

/**
 * Exported function to register the template
 * 
 * @param {PopupRenderer} renderer static PopupRenderer class
 * 
 * @memberof vef.map.popup.templates
 */
export function measurementsLayer(renderer) {

    const template = (content, response, layer, style) => {
        if (!content.features) content = { features: [content] };

        const responses = [];
        for (let i = 0; i < content.features.length; i++) {
            const feature = content.features[i];
            const properties = feature.properties;
            let title = layer.title;

            const options = {};
            if (layer instanceof DwsLayer) {
                options.fields = {};
                for (let key in properties) {
                    const parts = key.split(":");
                    const name = parts[parts.length - 1];
                    options.fields[name] = key;
                }
            } else if ("Event" in properties) {
                title = `Event: ${properties.Event}`;
            } else if ("event" in properties) {
                title = `Event: ${properties.event}`;
            }

            let html = null;

            if (style == "sidebar") {
                html = document.createElement("div");

                plot(html, layer, feature, generateTable(properties, Object.assign(options, { title: "Properties" })));
            } else {
                html = generateTable(properties, options);
            }

            if (html) responses.push({
                response: response,
                feature: feature,
                layer: layer,
                title: title,
                html: html
            });
        }

        return responses;
    };

    renderer.registerTemplate('measurements_layer', template);
}